import { render, staticRenderFns } from "./MaterialsForm.vue?vue&type=template&id=6e42b071&"
import script from "./MaterialsForm.vue?vue&type=script&lang=js&"
export * from "./MaterialsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports